import Hero from "../Components/Hero";
import Navbar from "../Components/Navbar";
import AboutImg from "../Assets/2.jpg";
import Footer from "../Components/Footer";
import AboutUs from "../Components/AboutUs";
import ContactForm from "../Components/ContactForm";

function contact() {
  return (
    <>
      <Navbar />
      <Hero
        cName="hero-mid"
        heroImg={"https://media.istockphoto.com/id/1484130372/photo/tropical-forest-on-the-island-of-borneo-malaysia.webp?b=1&s=170667a&w=0&k=20&c=VaFkBXK3KuZlpQnF1d7HAGgkuQU00ffIbgD1d5s0Yw0="}
        title="Contact"
        btnClass="hide"
      />
      <ContactForm />
      <Footer />
    </>
  );
}

export default contact;
